import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tracker" }
const _hoisted_2 = { class: "head center" }
const _hoisted_3 = { class: "head-content" }
const _hoisted_4 = { class: "track" }
const _hoisted_5 = { class: "table-head center" }
const _hoisted_6 = { class: "cell" }
const _hoisted_7 = { class: "cell" }
const _hoisted_8 = { class: "cell-icon" }
const _hoisted_9 = { class: "cell" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PulseButton = _resolveComponent("PulseButton")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_TrackerSelect = _resolveComponent("TrackerSelect")
  const _component_TrackerFilters = _resolveComponent("TrackerFilters")
  const _component_Loader = _resolveComponent("Loader")
  const _component_PulseEmpty = _resolveComponent("PulseEmpty")
  const _component_TopicItem = _resolveComponent("TopicItem")
  const _component_TrackerItem = _resolveComponent("TrackerItem")
  const _component_CollapseGroup = _resolveComponent("CollapseGroup")
  const _component_PulseBottom = _resolveComponent("PulseBottom")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _directive_resize = _resolveDirective("resize")

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PulseButton, {
        icon: "arrow-left",
        class: "back",
        text: "Back to Signals",
        color: "var(--brand-700)",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('toggle-tab')))
      }),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, [
          _createTextVNode(" Tracked Companies, People & Topics "),
          _createElementVNode("div", { class: "description" }, " Each company & person is continuously monitored by a dedicated AI agent. ")
        ], -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TrackerSelect, { options: $data.TRACKER_OPTS }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                primary: "",
                small: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    icon: "plus",
                    size: "1.6rem",
                    small: "",
                    stroke: "var(--base-white)"
                  }),
                  _cache[2] || (_cache[2] = _createTextVNode(" Track "))
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["options"])
        ])
      ]),
      _createVNode(_component_TrackerFilters, {
        ref: "filters",
        class: "filters",
        "type-counts": $options.type_counts,
        loading: $options.loading,
        onUpdateFilters: _cache[1] || (_cache[1] = $event => ($data.filters = $event))
      }, null, 8 /* PROPS */, ["type-counts", "loading"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Icon, {
          size: "1.6rem",
          stroke: "var(--brand-700)",
          "stroke-width": "1",
          icon: "building-02"
        }),
        _cache[4] || (_cache[4] = _createTextVNode(" Companies "))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Icon, {
            size: "1.6rem",
            stroke: "var(--brand-500)",
            "stroke-width": "1",
            icon: "users"
          })
        ]),
        _cache[5] || (_cache[5] = _createTextVNode(" People "))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Icon, {
          size: "1.6rem",
          stroke: "var(--brand-700)",
          "stroke-width": "1",
          icon: "activity"
        }),
        _cache[6] || (_cache[6] = _createTextVNode(" Signals "))
      ])
    ]),
    _createVNode(_component_ScrollBar, {
      ref: "scroller",
      class: "scroller",
      fade: "",
      "observer-threshold": 1,
      "bar-x-offset": "-2rem",
      onWheel: $options.onWheel
    }, {
      default: _withCtx(() => [
        ($options.loading && $options.empty)
          ? (_openBlock(), _createBlock(_component_Loader, {
              key: 0,
              huge: ""
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" Loading pulse... ")
              ])),
              _: 1 /* STABLE */
            }))
          : ($options.empty)
            ? (_openBlock(), _createBlock(_component_PulseEmpty, {
                key: 1,
                "items-name": "trackers",
                filters: $options.has_filters,
                onClear: $options.clearAll
              }, null, 8 /* PROPS */, ["filters", "onClear"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_CollapseGroup, {
                  name: "list",
                  class: "pulse-items",
                  items: $options.items,
                  duration: 300
                }, {
                  default: _withCtx(({item}) => [
                    (item.type === 'topic' || item.shared_topic_id)
                      ? (_openBlock(), _createBlock(_component_TopicItem, {
                          key: 0,
                          item: item,
                          "chosen-id": $props.chosenId,
                          class: "pulse-item center"
                        }, null, 8 /* PROPS */, ["item", "chosen-id"]))
                      : (_openBlock(), _createBlock(_component_TrackerItem, {
                          key: 1,
                          ref: item.id,
                          item: item,
                          class: "pulse-item center",
                          "chosen-id": $props.chosenId,
                          "tracker-width": $data.tracker_width,
                          search: !!$data.filters?.search,
                          onClick: $event => (_ctx.$debounce_175($options.editCompany, item.id))
                        }, null, 8 /* PROPS */, ["item", "chosen-id", "tracker-width", "search", "onClick"]))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["items"]),
                _createVNode(_component_PulseBottom, {
                  ref: "bottom",
                  class: "bottom center",
                  atend: $options.tracker_atend,
                  loading: $options.loading
                }, null, 8 /* PROPS */, ["atend", "loading"])
              ], 64 /* STABLE_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onWheel"])
  ])), [
    [_directive_resize, $options.onResize]
  ])
}